import React, { Fragment, useState } from "react";
import "./contact-us.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SectionContainer from "../../../components/landing/section-container";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Calendly from "../../../components/landing/calendly";
import { Box, Divider, Typography } from "@mui/material";

function ContactUsPage() {
  const [userName, setUserName] = useState("");

  return (
    <SectionContainer
      id="contact-us"
      title="Contáctenos"
      subtitle="Tienes dos formas"
    >
      <Fragment>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography>1. Para dudas via WhatsApp</Typography>
            <TextField
              required
              onChange={(evt) => setUserName(evt.target.value)}
              id="outlined-basic"
              label="Nombre"
              variant="outlined"
              helperText="Digite su nombre para habilitar el botón de contactar"
            />
            <Button
              href={encodeURI(
                `https://wa.me/50687246212?text=Hola, mi nombre es ${userName}, y estoy interesad@ en la residencia Cactus. Quisiera consultar sobre la disponibilidad de habitaciones.`
              )}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              endIcon={<WhatsAppIcon />}
              disabled={!userName.trim()}
              sx={{ maxWidth: 200, marginTop: 5 }}
            >
              Contactar
            </Button>
          </Box>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography>2. Para agendar visita usar</Typography>
            <Calendly />
          </Box>
        </Box>
      </Fragment>
    </SectionContainer>
  );
}

export default ContactUsPage;
